export default "__VITE_ASSET__e351acc0__"